import { I18n } from '@cainiaofe/cn-i18n';

export default new I18n({ locale: {}, packageName: 'cn-ui-lowcode-dev' });
